export enum Shape {
  BOX = 'BOX',
  CYLINDER = 'CYLINDER',
}
